<div class="home-component mt-3">
  <h1>{{ homeAvisDePubMessages.welcome | translate }}</h1>
  <div class="row mt-3">
    <div *ngIf="isListAvailable | async"  class="col-md-4">
      <app-home-block [buttonLink]="'/avisdepublicite/listerAvisPub'"
                      [buttonName]="homeAvisDePubMessages.access | translate" [button]="true"
                      [title]="homeAvisDePubMessages.lister | translate"
                      [textContent]="homeAvisDePubMessages.lister_desc | translate"
                      [ariaLabelValue]="homeAvisDePubMessages.lister_aria"></app-home-block>
    </div>
    <div *ngIf="isCreateAvailable | async" class="col-md-4">
      <app-home-block [buttonLink]="'/avisdepublicite/creerAvisPub'"
                      [buttonName]="homeAvisDePubMessages.access | translate" [button]="true"
                      [title]="homeAvisDePubMessages.creer | translate"
                      [textContent]="homeAvisDePubMessages.creer_desc | translate"
                      [ariaLabelValue]="homeAvisDePubMessages.creer_aria"></app-home-block>
    </div>
    <div *ngIf="displayPreference && (isPreferenceAvailable | async)" class="col-md-4">
      <app-home-block [buttonLink]="'/preferencesAvisPub'"
                      [buttonName]="homeAvisDePubMessages.access | translate" [button]="true"
                      [title]="homeAvisDePubMessages.preferences | translate"
                      [textContent]="homeAvisDePubMessages.preferences_desc | translate"
                      [ariaLabelValue]="homeAvisDePubMessages.preferences_aria"
                      *ngIf="displayPreference"></app-home-block>
    </div>
  </div>
</div>

